import { Tooltip } from "@mui/material";
import {
	BoltOutlined,
	DeveloperBoardOutlined,
	DeviceThermostatOutlined,
	HubOutlined,
	MemoryOutlined,
	NetworkCheckOutlined,
	NotificationsNoneOutlined,
	SensorsOutlined,
	StorageOutlined,
	WifiOffOutlined,
} from "@mui/icons-material";

// Ícone por chave do catálogo semente (TipoAlerta.chave) — o padrão global
// da feature, usado na aba Exibição da tela /config e no início do título do
// alerta nas tabelas (Incidentes e Análise de padrão). Tipo criado pelo
// operador (chave fora da lista) e alerta fora do catálogo caem no sino
// genérico.
export const ICONE_TIPO = {
	host_down: WifiOffOutlined,
	temperatura: DeviceThermostatOutlined,
	cpu: DeveloperBoardOutlined,
	memoria: MemoryOutlined,
	trafego: NetworkCheckOutlined,
	energia: BoltOutlined,
	disco: StorageOutlined,
	onu: SensorsOutlined,
	// Mesmo ícone da tela "Links e Sessões" do menu.
	link_sessao: HubOutlined,
	// O especial "Não catalogados" usa o sino — o mesmo fallback dos alertas
	// fora do catálogo nas tabelas.
	nao_catalogado: NotificationsNoneOutlined,
};

// Marcador do tipo do alerta: ícone (glifo diz O QUÊ) + Tooltip com o nome
// do tipo. A cor fica com o chamador (via sx) — nas tabelas ela carrega a
// severidade do alerta, como na aba Exibição.
export default function IconeTipoAlerta({ chave, nome, sx }) {
	const Icone = ICONE_TIPO[chave] || NotificationsNoneOutlined;
	return (
		<Tooltip title={nome || "Tipo não catalogado"} arrow>
			<Icone sx={{ fontSize: 16, flexShrink: 0, ...sx }} />
		</Tooltip>
	);
}
